import { ActionReducerMap } from '@ngrx/store';
import {
  JobEntityState,
  initialJobState,
  jobReducer,
} from '../job/job.reducer';

export const FEATURE_KEY = 'DashboardFeatureJob';
export interface DashboardFeatureJobState {
  jobs: JobEntityState;
}

export const initialDashboardFeatureJobState = {
  jobs: initialJobState,
};

export const reducers: ActionReducerMap<DashboardFeatureJobState> = {
  jobs: jobReducer,
};
